import { render } from "./Index.vue?vue&type=template&id=41bd3da2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=41bd3da2&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bd3da2"]])

export default __exports__